
export const data = ["社会性しか売れるものがない皆さん","それExcelでできるよ","でもそれExcelで良いじゃん", "3D棒グラフだ、◯せ!","データさえあれば非常に簡単にできる",
"プログラミング、教えること何もない","死ぬまで苦しもうな","どれだけ全体のレベルが低くても学年主席は毎年1人いるんだよ、そんなものに意味はあるか？",
"実務経験で実力が伸びるみたいな幻想、課題で手一杯の人には無理だぞ","技術力がないせいで課題が大変なんだから課題諦めて技術力上げた方が良くない？",
"いつでもみんなのそばにいるよ","みんなで仲良く劣った技術を採用して文明を衰退させような","この宇宙の不幸は大体光が遅いのが悪い",
"匿名じゃないと質問しにくいのはわかるけど、教員がそういう人を採用したいと思うのかはよく考えた方がいいですね",
"若者の不労所得で飯が食いたい",
"お前らが知の高速道路だと思って走ってるところは自動車教習所だよ",
"人間はReactが下手",
"地獄への道が善意で舗装されているように、世のクソアプリはみんなの「あれば良さそう」って無責任な善意から生まれてくるんだぞ",
"あればいいなを作るのは地獄なんだよなぁ",
"勉強する価値はあるけどJSはクソ言語だぞ！！！",
"結局夜の方が捗るので人間を諦めた方が良い",
"JavaScriptはWebブラウザの上で動かすにも向いてないぞ",
"nullを食べて腹を壊した",
"nullの食べ過ぎで胃もたれ",
"我々にブラウザ選択の自由を",
"学問って、相手の立場がなんであろうが異論があれば殴って良いって意味じゃなかったですっけ…",
"食事はとった方がいいし、睡眠はとった方がいい",
"養分にされないためのチャンスは死ぬほど（死ぬほど）与えてるつもりなので活用してね",
"苦しくてしょうもない仕事ばっかりやってるから儲からなくて給料も出ないんですよ",
"JavaScriptも負けないぐらいクソだから覚悟しとけよ",
"Javaをdisって尾崎先生と北原先生に刺されたりPythonをdisって宮田先生と大澤先生に刺されたりしたい",
"Pythonは悪い文明"]